import { PagePath } from 'constants/pagePath';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';
import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
import { getMaxLengthErrorMessage } from 'views/templates/accountOpen/common';
import { AddSubUserParam, useAddSubUserMutation } from 'views/utils/graphql/graphql';
import useOnceSubmit from 'views/utils/useOnceSubmit';
import * as Yup from 'yup';

const phoneNumberErrorWord = '11桁の半角数字で入力してください';
const emailErrorWord = 'メールアドレスの形式で入力してください（例: example@example.com）';
const addSubUserParamValidation = Yup.object().shape({
  PhoneNumber: Yup.string()
    .required(phoneNumberErrorWord)
    .matches(/^[0-9]{11}$/gi, phoneNumberErrorWord),
  MailAddress: Yup.string().trim().email(emailErrorWord).required(emailErrorWord).max(255, getMaxLengthErrorMessage(255)),
});

export const useSubUserAdd = () => {
  const [_response, addSubUserInner] = useAddSubUserMutation();
  const { showError } = useGlobalToastHandler();
  const { modalProps, showMessageModal } = useMessageModal();

  const navigate = useNavigate();

  const addSubUser = useOnceSubmit<AddSubUserParam>(
    {
      onSubmit: async (param) => {
        const res = await addSubUserInner({
          input: {
            MailAddress: param.MailAddress,
            PhoneNumber: param.PhoneNumber,
          },
        });
        if (!res?.data) return;

        if (res.data.AddSubUser?.Code === 0) {
          showMessageModal('登録メールを送信しました', () => navigate(PagePath.SubUser));
        } else {
          showError(res.data.AddSubUser?.Message);
        }
      },
    },
    [addSubUserInner, navigate],
  );

  const formik = useFormik<AddSubUserParam>({
    initialValues: {
      MailAddress: '',
      PhoneNumber: '',
    },
    onSubmit: addSubUser,
    validationSchema: addSubUserParamValidation,
    validateOnBlur: false,
    validateOnChange: true,
  });

  return {
    formik,
    modalProps,
  };
};
